<script>
export default {
  name: "DidoMillesimeTabRefsNomencs",
};
</script>

<script setup>
import DidoResourcesPagination from "../../commons/resources-pagination/Pagination.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  refsnomencs: { type: Object, required: true },
});
</script>

<template>
  <div>
    <DidoResourcesPagination
      :api-url="props.apiUrl"
      :resources="props.refsnomencs"
      type="refs"
    />
  </div>
</template>
